import { createApi } from '@reduxjs/toolkit/query/react'
import { baseApi } from './utils'

export const tariffBandApi = createApi({
	reducerPath: 'tariffBand',
	...baseApi('/tariff-band/'),
	endpoints: builder => ({
		getAncillaryChargeView: builder.query({
			query: ({ tariffBandId, ancillaryChargeId }) =>
				`ancillary-charge/view.php?tariffBandId=${tariffBandId}&ancillaryChargeId=${ancillaryChargeId}`,
		}),
	}),
})

export const { useGetAncillaryChargeViewQuery } = tariffBandApi
